export { uk } from '@payloadcms/translations/languages/uk'
